import { useChat } from "@/features/chat"
import { cn } from "@/lib/utils"
import CreditsIcon from "@/assets/img/CreditsV4.webp"
import Profile from "@/assets/svg/advisors/Profile.svg?react"

interface WebappHeaderProps {
  title?: string
  onCreditsClick?: () => void
  onProfileClick?: () => void
}

export function WebappHeader({
  title = "Advisors",
  onCreditsClick,
  onProfileClick,
}: WebappHeaderProps) {
  const { userCreditsCount } = useChat()

  return (
    <header
      data-slot="webapp-header"
      className="fixed left-1/2 top-0 z-30 flex h-14 w-full max-w-app -translate-x-1/2 items-center justify-center bg-dark-base"
    >
      <button
        type="button"
        onClick={onCreditsClick}
        className={cn(
          "absolute left-5 top-1/2 flex h-8 -translate-y-1/2 items-center gap-1 rounded-[20px] py-1.5 pl-2 pr-3",
          "bg-gradient-to-r from-[rgba(100,30,220,0.3)] via-[rgba(214,0,169,0.3)] to-[rgba(255,83,127,0.3)]",
        )}
      >
        <img src={CreditsIcon} alt="Stars" width={20} height={20} className="size-5" />
        <span className="font-body text-sm font-medium text-white">{userCreditsCount ?? 0}</span>
      </button>

      <h1 className="font-display text-[22px] font-medium text-purple-light">{title}</h1>

      <button
        type="button"
        onClick={onProfileClick}
        aria-label="Profile"
        className="absolute right-5 top-1/2 size-9 -translate-y-1/2 [&_svg]:size-9"
      >
        <Profile />
      </button>
    </header>
  )
}
